import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { AppModeSwitchComponent } from "./app-mode-switch.component";

@NgModule({
  declarations: [AppModeSwitchComponent],
  imports: [CommonModule],
  exports: [AppModeSwitchComponent],
})
export class AppModeSwitchModule {}
